<template>
  <div>
    <PlantillaContenido>
      <div slot="titulo">                     
       <i class="fas fa-home icon"></i>
        Inicio
        </div>
      <div slot="breadCrumb">
      <nav class="breadcrumb" aria-label="breadcrumbs">
                  <ul> 
                    <li class="is-active">
                     <router-link :to="{name:'administrativeReport'}" >
                        <span class="has-text-black" >
                          <i class="fas fa-home icon"></i> 
                             
                        inicio
                      </span>
                    </router-link>
                        
                      </li>
                      <li></li>
                  </ul>
                </nav>
  
      </div>
      <div slot="contenido">
        <EditProfile
          v-if="isComponentEditActive"
          :isComponentEditActive="isComponentEditActive"
          :closeEdit="closeEdit"
          :nameUserConnect="nameUserConnect"
          :user_id="user_id"
        ></EditProfile>
        <changePass
          v-if="isComponentPassActive"
          :isComponentPassActive="isComponentPassActive"
          :closeEditPassword="closeEditPassword"
          :user_id="user_id"
        ></changePass>
        <div
          class="column is-12"
        >
          <div class="p-1">
            <div class="columns is-variable">
              <div class="column is-12-desktop is-12-tablet">
                <div class="card">
                  <div class="card-content">
                    <div class="media">
                      <div class="media-left">
                        <figure class="image is-96x96">
                          <img src="\icono.png" />
                        </figure>
                      </div>
                      <div class="media-content">
                        <p class="title is-4">{{userName}}</p>
                        <p class="subtitle is-6" style="margin-bottom: 0.8rem">{{email.email}}</p>
                        <p class="subtitle is-8" style="margin-bottom: 1rem">{{stablishment}}</p>
                        <p class="subtitle is-6">{{profile}}</p>
                      </div>
                    </div>

                    <div class="content">
                      <div class="field is-grouped">
                        <div class="control">
                          <button class="button is-small is-primary" @click="openEdit(email.id)">
                            <b-icon pack="fas" icon="user"></b-icon>
                            <span>Editar Perfil</span>
                          </button>
                        </div>
                        <div class="control">
                          <button class="button is-small is-dark" @click="openPass(email.id)">
                            <b-icon pack="fas" icon="key"></b-icon>
                            <span>Cambiar Contraseña</span>
                          </button>
                        </div>
                      </div>
                      <time datetime="2016-1-1">{{fecha}}</time>
                    </div>
                  </div>
                </div>
                <br />
                <slot name="contenido"></slot>
              </div>
            </div>
          </div>
        </div>
      </div>
    </PlantillaContenido>
  </div>
</template>
<script>
import ChangePass from '../../components/changePass.vue';
import EditProfile from '../../components/EditProfile.vue';
import PlantillaContenido from "../../template/PlantillaContenido";

export default {
  name: "AdministrativeHome",
  components: {
    PlantillaContenido: PlantillaContenido,
    EditProfile,
    ChangePass,
  },
   data() {
    return {
      profile: "",
      detectedError: null,
      userName: "Cargando ...",
      email: "",
      fecha: "",
      isModalReloginShown: false,
      isComponentEditActive: false,
      user_id: "",
      isComponentPassActive: false,
      stablishment: "",
      src: "",
    };
  },
  created: function () {
    console.log('home');
    this.nameUserConnect();
  },
  methods: {
    closeEdit() {
      this.user_id = null;
      this.isComponentEditActive = false;
    },
    closeEditPassword() {
      this.isComponentPassActive = false;
    },
    nameUserConnect: function () {
      var mes = [
        "Enero",
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre",
      ];
      var inicio = new Date();
      this.fecha =
        inicio.getDate() +
        " de " +
        mes[inicio.getMonth() + 1] +
        " del " +
        inicio.getFullYear();
      this.userName = window.localStorage.getItem("userName");
      this.email = JSON.parse(window.localStorage.getItem("user"));
      this.$http
        .get(
          `api/${localStorage.getItem("perfil")}/stablishment/` +
            window.localStorage.getItem("stablishment_id")
        )
        .then((response) => {
          console.log("PUT:", response);
          this.stablishment = response.body.stablishment.name;
        });
    },
    openEdit: function (id) {
      (this.user_id = id), (this.isComponentEditActive = true);
    },
    openPass: function (id) {
      (this.user_id = id), (this.isComponentPassActive = true);
    },
  }
};
</script>